import { isAssignedDelivery } from 'src/components/dispatch/vehicleRowExpand/assignedDelivery';
import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * その地点を訪れている行（回転）の ID。
 *
 * 同一納品先を複数台で配送していても、地図の地点を押すと 1 台しか選ばれなかった。
 * 押した地点に紐づく車両・回転をまとめて選べるようにする。
 *
 * 判定は共通配送先パネル (buildSharedDestinationVM) と同じ「配車済みの降地カードで
 * placeKey が一致」。D&D 直後の未反映カードや固定ルートの仮カードは、まだその車両の
 * 計画ではないので数えない。
 *
 * 「配送リストの地点表示 = 名称でまとめる」設定では placeKey に名称が入るので、判定も
 * 名称単位になる。パネルと同じクリックで走る処理なので、単位はパネルと揃える。
 */
export function collectRowIdsAtPlace(
  placeKey: string,
  rowGroups: readonly VehicleRowGroup[],
): string[] {
  // placeKey を持たないカード（座標が引けない地点）を空文字と一致させない
  if (!placeKey) return [];

  const rowIds: string[] = [];
  rowGroups.forEach((group) => {
    group.rows.forEach((row) => {
      const visits = row.cards.some(
        (card) => card.type === 'delivery' && isAssignedDelivery(card) && card.placeKey === placeKey,
      );
      if (visits) rowIds.push(row.rowId);
    });
  });
  return rowIds;
}
